/**
 * Why the brand-level "Write refunds" button is unavailable, or null when it is available.
 *
 * ITS OWN FILE BECAUSE IT IS A RULE, NOT A RENDER. The answer decides whether a button that
 * moves money in a merchant's store can be pressed, and a rule like that should be assertable
 * without mounting the tab it happens to live on.
 *
 * REFUSES ONLY WHEN NOT ONE CONNECTED RETAILER HAS IT ON. A sweep spans every retailer the
 * brand sells on, so refusing because a single retailer is switched off would block work that
 * is perfectly valid elsewhere.
 *
 * NULL WHEN THERE ARE NO CONNECTIONS AT ALL, deliberately. "Switched off everywhere" is not
 * true of a brand connected to nowhere, and saying it would send somebody looking for a switch
 * to change. The sweep itself finds nothing and says so.
 *
 * Compared with === true because the field is absent, not false, when the route that feeds
 * this forgets to select it - and `undefined` must not read as "switched on".
 */
export function refundsOffEverywhere(brandMarketplaces) {
  const connected = (brandMarketplaces || []).filter((bm) => bm?.enabled !== false);
  if (connected.length === 0) return null;
  return connected.some((bm) => bm?.marketplace?.writeRefundsToShopify === true)
    ? null
    : 'Writing refunds is switched off for every retailer this brand is connected to.';
}

export default refundsOffEverywhere;
